import {Widget} from 'common/src/modules/dynamicParameters/widgets/widgets.types';

export default function getMockTemplateWidgets(): Widget[] {
  return [
    {
      id: 101,
      uiName: 'Countdown Widget',
      description: 'Countdown timer with customizable typography and colors.',
      features: [],
      manifest: [],
      isActive: true,
    },
    {
      id: 102,
      uiName: 'Product Card Widget',
      description: 'Product card block with title, price, and background image.',
      features: [],
      manifest: [],
      isActive: true,
    },
    {
      id: 103,
      uiName: 'Ratings Widget',
      description: 'Star-rating and review-count block for product highlights.',
      features: [],
      manifest: [],
      isActive: true,
    },
  ];
}
